import React from "react";
import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import SectionPersonalityTypes from "../../components/SectionPersonalityTypes/SectionPersonalityTypes";
import SectionProfessionals from "../../components/SectionProfessionals/SectionProfessionals";
import Footer from "../../components/Footer/Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <main>
        {/* Use negative margin on the first section to visually connect with hero */}
        <div id="start" style={{ marginTop: "-40px", paddingTop: "80px" }}>
          <About />
        </div>
        <SectionPersonalityTypes />
        {/* <SectionProfessionals /> */}
      </main>
      <Footer />
    </>
  );
}
